import React, { useContext, useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import ProgressButtons from "../ProgressButtons";
import RegistrationContext from "../../../context/registration/registrationContext";


// accessToComputerAtHome - Yes/No
// accessToTheInternetAtHome - Yes/No

const R13HomeSurvey = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    formData: { firstName, accessToComputerAtHome, accessToTheInternetAtHome },
    onFormDataChange,
    pass: { homesurvey },
  } = registrationContext;

  const homeSurvey =
    accessToComputerAtHome !== "" && accessToTheInternetAtHome !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="sub-form">
        <h2 className="">
          Home Survey <span>(12/15)</span>
          <hr />
        </h2>
        <div className="group">
          <div>
            <div className="item">
              <div className="asterisk-group">
                <h3>Does {firstName} have Access to Computer at Home?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border: homesurvey
                    ? "1px solid #ccc;"
                    : accessToComputerAtHome !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={accessToComputerAtHome["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="accessToComputerAtHome"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={accessToComputerAtHome["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="accessToComputerAtHome"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>Does {firstName} have Access to the Internet at Home?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border: homesurvey
                    ? "1px solid #ccc;"
                    : accessToTheInternetAtHome !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={accessToTheInternetAtHome["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="accessToTheInternetAtHome"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={accessToTheInternetAtHome["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="accessToTheInternetAtHome"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ProgressButtons validation={homeSurvey} name="homesurvey" />
    </>
  );
};

export default R13HomeSurvey;
